var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskSidebarImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M308.42,385.73h-9a3,3,0,0,0-3,3v9a3,3,0,0,0,3,3h9a3,3,0,0,0,3-3v-9A3,3,0,0,0,308.42,385.73Zm-4.5,3.75h3.75a.75.75,0,0,1,0,1.5h-3.75a.75.75,0,0,1,0-1.5Zm4.5,3.75a.752.752,0,0,1-.75.75h-2.25a.75.75,0,0,1,0-1.5h2.25A.747.747,0,0,1,308.42,393.23ZM300.26,395l-1.065-1.057c-.008-.007-.008-.015-.015-.022a.747.747,0,0,1,.015-1.057.763.763,0,0,1,1.065.015l.525.532,1.6-1.59a.748.748,0,1,1,1.057,1.058L301.318,395A.747.747,0,0,1,300.26,395Zm3.66,1.98a.75.75,0,1,1,0-1.5h3.75a.75.75,0,1,1,0,1.5Z",
    transform: "translate(-296.42 -385.73)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskSidebarImage);
export default __webpack_public_path__ + "static/media/task-sidebar-image.566767533eca818a9181147c3286fd05.svg";
export { ForwardRef as ReactComponent };